/* K2 draft: coordinated sticky header, with static responsive search guidance. */
if (!customElements.get('k2-smart-header')) {
  customElements.define('k2-smart-header', class extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('store-header');
      this.section = this.closest('.cc-header');
      if (!this.header || !this.section) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.input = this.header.querySelector('#header-search');
      this.mobile = window.matchMedia('(max-width: 768.98px)');
      this.updatePrompt = () => {
        if (this.input) {
          const text = this.mobile.matches
            ? 'Search car parts…'
            : 'Search by make, model, year, part or brand';
          this.input.placeholder = text;
          this.input.setAttribute('aria-label', 'Search by make, model, year, part or brand');
        }
      };
      this.updatePrompt();
      window.addEventListener('resize', this.updatePrompt, options);
      if (!this.header.hasAttribute('data-k2-is-sticky')) return;
      this.section.classList.add('cc-header--sticky', 'k2-smart-sticky');
      this.lastY = window.scrollY;
      this.direction = 0;
      this.travel = 0;
      this.compact = false;
      this.measure = () => {
        if (!this.compact && !this.settling) {
          this.section.style.height = this.header.getBoundingClientRect().height + 'px';
        }
      };
      this.measure();
      this.observer = new ResizeObserver(() => {
        this.measure();
        this.updateOffsets();
      });
      this.observer.observe(this.header);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
          const y = Math.max(0, Math.min(window.scrollY, maxY));
          const delta = y - this.lastY;
          const direction = Math.sign(delta);
          this.lastY = y;
          if (this.isInteracting()) {
            this.setCompact(false);
            this.travel = 0;
            return;
          }
          if (y < 100) {
            this.setCompact(false);
            this.travel = 0;
            return;
          }
          if (direction !== this.direction) this.travel = 0;
          this.direction = direction;
          this.travel += Math.abs(delta);
          if (this.travel >= 12) {
            this.setCompact(direction > 0 && y > 180);
            this.travel = 0;
          }
        });
      };
      window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
      this.header.addEventListener('focusin', () => this.setCompact(false), options);
      window.addEventListener('resize', () => {
        this.setCompact(false);
        this.lastY = window.scrollY;
        this.measure();
      }, options);
      this.header.addEventListener('transitionend', () => this.updateOffsets(), options);
      this.updateOffsets();
    }
    isInteracting() {
      return this.header.contains(document.activeElement)
        || document.body.classList.contains('fixed')
        || document.body.classList.contains('overlay-predictive-search')
        || Boolean(this.header.querySelector('details.is-open, predictive-search[open]'));
    }
    setCompact(compact) {
      if (compact === this.compact) return;
      if (compact) this.measure();
      this.compact = compact;
      document.documentElement.toggleAttribute('data-k2-header-compact', compact);
      clearTimeout(this.settleTimer);
      this.settling = true;
      this.settleTimer = setTimeout(() => {
        this.settling = false;
        this.measure();
        this.updateOffsets();
      }, 350);
    }
    updateOffsets() {
      const rect = this.header.getBoundingClientRect();
      const root = document.documentElement;
      root.style.setProperty('--header-height', rect.height + 'px');
      root.style.setProperty('--header-end', rect.bottom + 'px');
      root.style.setProperty('--header-end-padded', (rect.bottom + (this.mobile.matches ? 20 : 56)) + 'px');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.settleTimer);
      this.section?.style.removeProperty('height');
      this.section?.classList.remove('k2-smart-sticky');
      document.documentElement.removeAttribute('data-k2-header-compact');
    }
  });
}
